import { render, staticRenderFns } from "./SaturationCurves.vue?vue&type=template&id=3baa5349&scoped=true&"
import script from "./SaturationCurves.vue?vue&type=script&lang=js&"
export * from "./SaturationCurves.vue?vue&type=script&lang=js&"
import style0 from "./SaturationCurves.vue?vue&type=style&index=0&id=3baa5349&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baa5349",
  null
  
)

export default component.exports